var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-ckeditor',{attrs:{"config":_vm.config},on:{"fileUploadResponse":function($event){return _vm.onFileUploadResponse($event)}},model:{value:(_vm.formData.content),callback:function ($$v) {_vm.$set(_vm.formData, "content", $$v)},expression:"formData.content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }